export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";